import { render } from "./DemandForm.vue?vue&type=template&id=f376f5c8&scoped=true"
import script from "./DemandForm.vue?vue&type=script&lang=js"
export * from "./DemandForm.vue?vue&type=script&lang=js"

import "./DemandForm.vue?vue&type=style&index=0&id=f376f5c8&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f376f5c8"]])

export default __exports__